module.exports = __webpack_public_path__ + "static/media/GraphQL_Logo.a7f48025.png";